import Styles from './Loading.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const Loading = () => {
  return (
    <div className={Styles.loadingContainer}>
      <Skeleton className={Styles.loading} active paragraph={{ rows: 1 }} title={false} />
      <Skeleton className={Styles.loading} active paragraph={{ rows: 1 }} title={false} />
      <Skeleton className={Styles.loading} active paragraph={{ rows: 1 }} title={false} />
    </div>
  )
}
